export const cosignErrorCode = {
  OTP_RESEND_LIMIT_REACHED: 429120,
  OTP_RESEND_LIMIT_REACHED_2: 429121,
  RECAPTCHA_VALIDATION_FAILED: 403123,
  EMAIL_PROVIDER_NOT_SUPPORTED: 403280,
  EMAIL_DOMAIN_DENIED_GLOBALLY: 403281,
  EMAIL_DOMAIN_VERIFICATION_UNAVAILABLE: 503282,
} as const
